import { buildState, IEntityState } from '@briebug/ngrx-auto-entity';
import { JobNoBoxReason } from '@app/models';

export const {
  initialState: jobNoBoxReasonInitialState,
  selectors: jobNoBoxReasonSelectors,
  facade: JobNoBoxReasonFacadeBase,
} = buildState(JobNoBoxReason);

export function jobNoBoxReasonReducer(
  state = jobNoBoxReasonInitialState
): IEntityState<JobNoBoxReason> {
  return state;
}
